import { Box } from "@mui/material";
import { ParagraphText } from "../../../Libraries";
import styles from "./styles.module.css";

const DotsLoader = ({ message }) => {
  return (
    <Box className={styles.wrapper}>
      <Box className={styles.dotsWrapper}>
        <span className={`dotCircle ${styles.dot}`} />
        <span className={`dotCircle ${styles.dot}`} />
        <span className={`dotCircle ${styles.dot}`} />
      </Box>
      {message && (
        <ParagraphText className={`fontSize14 fontWeight500 newFontColor ${styles.message}`}>
          {message}
        </ParagraphText>
      )}
    </Box>
  );
};

export default DotsLoader;
